import { $on } from 'fxdom/es';

export const waitForTransitionEnd = (el) =>
  new Promise((resolve) => $on('transitionend', () => resolve(), { once: true })(el));
